import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const SurfaceExternalRetailPricesPDPPage = withCompass(
  () => import("../../pages/SurfaceExternalRetailPricesPDPPage")
);

export function BeccaSabnaniRoutes() {
  return (
    <Switch>
      <Route
        path="/bs/external-retail-prices-pdp"
        component={SurfaceExternalRetailPricesPDPPage}
      />
    </Switch>
  );
}

export const slug = "bs";
